import * as moment from 'moment';
import { IPossibleFilters } from 'src/views/Links/types';
import { getSearchQuery } from './getSearchQuery';
import { getParameterQueries } from './getParameterQueries';
import { store } from 'src/services/store';
import { groupBy } from 'lodash';

export default function createQuery({
  page,
  dateFrom,
  dateTo,
  showArchive = false,
  myLinks = false,
  parameters = [],
  searchTerm,
  linksPerPage = 10,
}: IPossibleFilters) {
  const DATE_FORMAT = `YYYY-MM-DDTHH:mm:ss`;
  const state = store.getState();
  const marketGroupName = state.settings.profileParameterName;

  const { markets = [], params = [] } = groupBy(parameters, (parameter) =>
    parameter.name === marketGroupName ? 'markets' : 'params'
  );
  const marketValues = markets.length > 0 ? markets[0].values : [];

  const query: any = {
    from: page ? (page - 1) * linksPerPage : 0,
    size: linksPerPage,
    sort: [
      {
        CreatedOn: {
          order: 'desc',
        },
      },
    ],
    query: {
      bool: {
        must: [
          {
            bool: {
              must: [
                ...(dateFrom && dateTo
                  ? [
                      {
                        range: {
                          CreatedOn: {
                            gte: moment(dateFrom).format(DATE_FORMAT),
                            lte: moment(dateTo).format(DATE_FORMAT),
                            _name: 'named_query',
                            boost: 1.1,
                          },
                        },
                      },
                    ]
                  : []),
                {
                  terms: {
                    MarketId: marketValues.map((market) => market.value),
                    boost: 1.1,
                    _name: 'named_query',
                  },
                },
                {
                  term: {
                    Hide: {
                      value: showArchive ? 1 : 0,
                      _name: 'named_query',
                      boost: 1.1,
                    },
                  },
                },
                ...(myLinks
                  ? [
                      {
                        term: {
                          CreatorUserName: {
                            value: state.user.userId,
                            _name: 'named_query',
                            boost: 1.1,
                          },
                        },
                      },
                    ]
                  : []),
              ],
              filter: [
                {
                  bool: {
                    must: getParameterQueries(params),
                    minimum_should_match: 1,
                  },
                },
              ],
            },
          },
          {
            bool: {
              should: searchTerm
                ? getSearchQuery(`*${searchTerm.toLowerCase()}*`)
                : [],
              minimum_should_match: 1,
            },
          },
        ],
      },
    },
  };

  return query;
}



// WEBPACK FOOTER //
// ./src/services/api/links/utils/createQuery.ts